import db from '@/firebase/init'

export default {

    data () {
        return {
          dishwasher100Cycles: {pages: [], page: 0},
          lastNCycles: 100 // const: how many data points there are in chartDishwasher100Cycles?
        }
    },

    methods: {

        chartDishwasher100Cycles() {

            this.chartError = null
            this.dishwasher100Cycles.cycles = 0
            this.dishwasher100Cycles.pages = []
      
            db.collection("devices/" + this.chartDev.id + "/washingCycles").doc('last2500').get().then((doc) => {
                if (doc.exists) {
      
                    this.dishwasher100Cycles.labels = []
                    this.dishwasher100Cycles.events = {filling:[]}
                    this.dishwasher100Cycles.data = {washingTankT:[], boilerT:[], waterConsumption:[]}
                    var min = 20
                    var d = doc.data().rows
                    var lastDay = ''
      
                    for(var i in d) {
      
                      // generate event time labels
                      var date = new Date(d[i].time);
                      var iso = date.toISOString().substr(0,10)
                      var label = (iso != lastDay) ? iso : ''
                      lastDay = iso
                      
                      // copy data
                      if(d[i].ev == 'cycle') {
                        this.dishwasher100Cycles.labels.push(label)
                        this.dishwasher100Cycles.events.filling.push(null)
                        this.dishwasher100Cycles.cycles++
                        for(var field in this.dishwasher100Cycles.data) {
                          if(field in d[i]) {
                            this.dishwasher100Cycles.data[field].push(d[i][field])
                          } else {
                            this.dishwasher100Cycles.data[field].push(null)
                          }
                        }
                      } else if('ev' in d[i] && d[i].ev == 'filling') {
                        this.dishwasher100Cycles.labels.push(label)
                        for(var field in this.dishwasher100Cycles.data) {
                          this.dishwasher100Cycles.data[field].push(null)
                        }
                        this.dishwasher100Cycles.events.filling.push(0)
                      }
                    }
      
                    var err = this.handleChartPoints(this.dishwasher100Cycles.data, this.dishwasher100Cycles.events, Math.trunc(min))
                    if(err) {
                      this.setChartError(err)
                      return
                    }
      
                    // calculate pages
                    if(this.lastNCycles < this.dishwasher100Cycles.cycles) {
                      this.dishwasher100Cycles.page = 0
                      var last = this.dishwasher100Cycles.cycles - 1
                      while(last > -1) {
                        var pageBeginning = last - this.lastNCycles + 1 < 0 ? 0 : last - this.lastNCycles + 1
                        this.dishwasher100Cycles.pages.push([
                          pageBeginning,
                          last
                        ])
                        last -= this.lastNCycles
                      }
      
                      // find pages edges in data
                      var indexPoints = 0
                      var dataPoints = 0
                      var page = this.dishwasher100Cycles.pages.length - 1
                      for(var i = 0; i < this.dishwasher100Cycles.events.filling.length; i++) {
                        if(this.dishwasher100Cycles.events.filling[i] == null) {
                          if(dataPoints == this.dishwasher100Cycles.pages[page][0]) {
                            this.dishwasher100Cycles.pages[page].push(indexPoints)
                          }
                          if(dataPoints == this.dishwasher100Cycles.pages[page][1]) {
                            this.dishwasher100Cycles.pages[page].push(indexPoints)
                            page--
                            if(page < 0) { break }
                          }
                          dataPoints++
                        }
                        indexPoints++
                      }
                    }
      
                    this.chartOptions = {
                      responsive: true,
                      maintainAspectRatio: false,
                      scales: {
                        xAxes: [{
                          ticks: {autoSkip: false}
                        }],
                        yAxes: [{
                          type: 'linear',
                          display: true,
                          position: 'left',
                          id: 'y-axis-1',
                          scaleLabel: {
                            display: true,
                            labelString: '°C'
                          },
                          ticks: {min: 20, max: 100}
                        }, {
                          type: 'linear',
                          display: true,
                          position: 'right',
                          id: 'y-axis-2',
                          gridLines: { drawOnChartArea: false }
                        }]
                      }
                    }
                    this.chartDishwasher100CyclesPage()
      
                } else {
                    this.setChartError(this.$t('common.nodoc'))
                }
            }).catch((error) => {this.setChartError(error)})
          },
      
          chartDishwasher100CyclesPage() {
            
            var data, events, labels
            if(this.dishwasher100Cycles.pages.length) {
              events = {filling:[]}
              data = {washingTankT:[], boilerT:[], waterConsumption:[]}
              labels = []
              var begin = (this.dishwasher100Cycles.pages.length - 1 == this.dishwasher100Cycles.page)
                ? 0
                : this.dishwasher100Cycles.pages[this.dishwasher100Cycles.page + 1][3] + 1
              var end = this.dishwasher100Cycles.page == 0
                ? this.dishwasher100Cycles.events.filling.length
                : this.dishwasher100Cycles.pages[this.dishwasher100Cycles.page - 1][2]
              for(var i = begin; i < end; i++) {
                for(var field in events) { events[field].push(this.dishwasher100Cycles.events[field][i]) }
                for(var field in data) { data[field].push(this.dishwasher100Cycles.data[field][i]) }
                labels.push(this.dishwasher100Cycles.labels[i])
              }
            } else {
              events = this.dishwasher100Cycles.events
              data = this.dishwasher100Cycles.data
              labels = this.dishwasher100Cycles.labels
            }
      
            this.chartData = {
              type: 'line',
              labels: labels,
              datasets: [
                this.getChartLineData({
                  type: 'line',
                  color: 'red',
                  spec: {
                    label: this.$t('dishwasher.washingTankT') + ', °C',
                    data: data.washingTankT
                  }
                }),
                this.getChartLineData({
                  type: 'line',
                  color: '#DEC20B',
                  spec: {
                    label: this.$t('dishwasher.boilerT') + ', °C',
                    data: data.boilerT
                  }
                }),
                this.getChartLineData({
                  type: 'event',
                  color: 'green',
                  spec: {
                    label: '◆ ' + this.$t('dishwasher.evClean'),
                    data: events.filling,
                    pointStyle: 'rectRot'
                  }
                }),
                this.getChartLineData({
                  type: 'line',
                  color: 'blue',
                  spec: {
                    label: this.$t('dishwasher.waterCons') + ', L',
                    data: data.waterConsumption,
                    fill: true,
                    yAxisID: 'y-axis-2'
                  }
                })
              ]
            }
          },
      
          turnDishwasher100CyclesPage(direction) {
            this.dishwasher100Cycles.page += direction
            if(this.dishwasher100Cycles.page < 0) {
              this.dishwasher100Cycles.page = this.dishwasher100Cycles.pages.length - 1
            }
            if(this.dishwasher100Cycles.page > this.dishwasher100Cycles.pages.length - 1) {
              this.dishwasher100Cycles.page = 0
            }
            this.chartDishwasher100CyclesPage()
          },
      
          chartDishwasherHourly() {
      
            this.chartError = null
      
            db.collection("devices/" + this.chartDev.id + "/logs").doc(
              this.getFlatDate(this.vjsdpDate)).get().then((doc) => {
                if (doc.exists) {
      
                    var events = {washing:[], cleaning:[]}
                    var data = {washingTankT:[], boilerT:[]}
                    var min = null
                    var d = doc.data().rows
                    d.sort((a,b) => (a.time - b.time))
                    
                    for(var i in d) {
      
                      // generate event time labels
                      var date = new Date(d[i].time);
                      if(date.getHours() < this.hours.h0 || date.getHours() > this.hours.h1 - 1) { continue; }
                      
                      // copy data
                      for(var field in data) {
                        if(field in d[i]) {
                          data[field].push({x: date, y: d[i][field]})
                          if((field == 'washingTankT' || field == 'boilerT') && (min == null || min > d[i][field])) {
                            min = d[i][field]
                          }
                        }
                      }
      
                      // events handling
                      for(var ev in events) {
                        if(ev in d[i] && d[i][ev]) {
                          events[ev].push({x: date})
                        }
                      }
      
                    }
      
                    var err = this.handleChartPoints(data, events, Math.trunc(min))
                    if(err) {
                      this.setChartError(err)
                      return
                    }
      
                    this.chartOptions = this.defaultChartOptions
      
                    this.chartData = {
                      type: 'line',
                      datasets: [
                        this.getChartLineData({
                          type: 'line',
                          color: 'red',
                          spec: {
                            label: this.$t('dishwasher.washingTankT') + ', °C',
                            data: data.washingTankT
                          }
                        }),
                        this.getChartLineData({
                          type: 'line',
                          color: '#DEC20B',
                          spec: {
                            label: this.$t('dishwasher.boilerT') + ', °C',
                            data: data.boilerT
                          }
                        }),
                        this.getChartLineData({
                          type: 'event',
                          color: 'green',
                          spec: {
                            label: '▲ ' + this.$t('dishwasher.evWash'),
                            data: events.washing,
                            pointStyle: 'triangle'
                          }
                        }),
                        this.getChartLineData({
                          type: 'event',
                          color: 'blue',
                          spec: {
                            label: '◆ ' + this.$t('dishwasher.evClean'),
                            data: events.cleaning,
                            pointStyle: 'rectRot'
                          }
                        })
                      ]
                    }
      
                } else {
                    this.setChartError(this.$t('common.nodoc'))
                }
            }).catch((error) => {this.setChartError(error)})
          }
    }

}


// WEBPACK FOOTER //
// ./src/components/Charts/Dishwasher.js